import { useNavigate } from "react-router-dom";
import { BigButton } from "../design/BigButton";
import { ASSETS } from "../lib/assets";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";
import { useChildProfile } from "../contexts/ChildProfileContext";

export function SplashScreen() {
  const navigate = useNavigate();
  const { status } = useAuth();
  const { selectedId } = useChildProfile();

  useEffect(() => {
    if (status !== "authed") return;
    const t = setTimeout(() => {
      if (selectedId) navigate(`/child/${selectedId}/home`, { replace: true });
      else navigate("/profiles", { replace: true });
    }, 1200);
    return () => clearTimeout(t);
  }, [status, selectedId, navigate]);

  return (
    <div className="wmleye-app splash" data-testid="splash-screen">
      <div className="splash__hero">
        <img src={ASSETS.logo} alt="With My Little EYE" className="splash__logo" data-testid="splash-logo" />
        <img src={ASSETS.mascotOllie} alt="Ollie the owl" className="splash__mascot" data-testid="splash-mascot" />
        <p className="splash__tagline" data-testid="splash-tagline">Find It. Hear It. Spell It.</p>
        {status === "guest" && (
          <div className="splash__cta">
            <BigButton onClick={() => navigate("/login")} data-testid="splash-signin">
              Sign in
            </BigButton>
            <BigButton
              variant="sun"
              onClick={() => navigate("/register")}
              data-testid="splash-register"
            >
              Create account
            </BigButton>
          </div>
        )}
      </div>
    </div>
  );
}
